import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import createReactClass from 'create-react-class'
import { cancelModalCSSClasses, cancelModalTexts } from './../../lib/helper'

const CancelModal = createReactClass({
	getInitialState: function() {
		return { loading: false, error: false }
	},
	close() {
		this.props.actions.closeModal()
	},
	remove() {
		const { gid, actions } = this.props
		this.setState({loading: true})
		actions.cancelMigration({ key: gid })
			.then(res => {
				this.setState({loading: false})
				this.close()
			})
			.catch(res => {
				this.setState({loading: false})
			})
	},
	genericModal() {
		const { migrate } = this.props
		const classInfo = cancelModalCSSClasses(migrate)
		const textsInfo = cancelModalTexts(migrate)
		return (
			<Modal show={true} onHide={this.close} className={`${classInfo.main} freighter-cancel-modal`}>
				<Modal.Header>
					<button className="close" onClick={this.close}><i className="mdi mdi-close"></i></button>
					<Modal.Title className="text-center">
						<span className="fw-600" style={{color:"#252E31", fontSize: '17px'}}>{textsInfo.title}</span>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body bsClass="bv-modal-body">
					<div className="col-xs-10 center-dom text-center bv-add-note-container">
						<p className="mt-2 line-height-18">{textsInfo.message}</p>
						<div className="v-center justify-content-center mb-2" style={{gap: '20px'}}>
							<button className={classInfo.primaryButton || 'bv-primary-button'} onClick={this.remove}>{textsInfo.primaryBtnText}</button>
							<button className={classInfo.secondaryButton || 'bv-secondary-button'} onClick={this.close}>{textsInfo.secondaryBtnText}</button>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		)
	},
	wpcomModal() {
		const { loading } = this.state
		const btnText = loading ? 'Cancelling migration ...' : 'Yes, cancel the migration'
		return (
			<Modal show={true} className="wpcom wpcom-cancel-modal">
				<Modal.Body bsClass="bv-modal-body">
					<div className="wpcom-migration-modal-container">
						<div className="wpcom-migration-modal">
							<div className="wpcom-migration-modal-content">
								<h1>Cancel migration</h1>
								<p className="my-1">If you cancel now, your site won't be migrated to WordPress.com. Are you sure you want to cancel?</p>
							</div>
							<div className="wpcom-migration-modal-buttons wpcom-migration-form">
								<button className="secondary" onClick={this.close}>No, continue migrating</button>
								<button onClick={this.remove} disabled={loading}>{btnText}</button>
							</div>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		)
	},
	render() {
		const { migrate } = this.props
		return migrate.get('origin') === ORIGIN.AUTOMATTIC ? this.wpcomModal() : this.genericModal()
	}
})

export default CancelModal
